import type { MapRegion } from "@/types"

export const victoriaRegion: MapRegion = {
    id: "victoria",
    name: "map.region.victoria",
    mapImage: require("@/assets/imgs/map/victoria/map-victoria.png"),
    decoImage: require("@/assets/imgs/map/victoria/map-victoria-deco.png"),
    decoAnimation: "spin",
    startNodeId: "vc-start",
    endNodeId: "vc-end",
    startDirection: "right",
    unlocked: false,
    order: 3,
    iconConfig: {
        question: {
            highlightIcon: require("@/assets/imgs/map/victoria/map-victoria-question-mark.png"),
            width: 213,
            height: 212,
        },
    },
    nodes: [
        {
            id: "vc-start",
            type: "start",
            level: 0,
            position: { x: 388, y: 729 },
            iconType: "question",
        },
        {
            id: "vc-brigid",
            type: "event",
            level: 1,
            position: { x: 767, y: 624 },
            eventId: "dlg-vc-brigid",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/victoria/map-victoria-event-brigid.png"),
                width: 228,
                height: 233,
            },
        },
        {
            id: "vc-evt4",
            type: "event",
            level: 2,
            position: { x: 788, y: 338 },
            eventId: "evt-vc-04",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/victoria/map-victoria-event-4.png"),
                width: 419,
                height: 379,
            },
        },
        {
            id: "vc-evt3",
            type: "event",
            level: 2,
            position: { x: 1174, y: 706 },
            eventId: "evt-vc-03",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/victoria/map-victoria-event-3.png"),
                width: 472,
                height: 319,
            },
        },
        {
            id: "vc-heidi",
            type: "event",
            level: 3,
            position: { x: 424, y: 470 },
            eventId: "dlg-vc-heidi",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/victoria/map-victoria-event-heidi.png"),
                width: 291,
                height: 247,
            },
        },
        {
            id: "vc-evt1",
            type: "event",
            level: 3,
            position: { x: 1260, y: 391 },
            eventId: "evt-vc-01",
            iconType: "question",
        },
        {
            id: "vc-evt2",
            type: "event",
            level: 4,
            position: { x: 1068, y: 211 },
            eventId: "evt-vc-02",
            iconType: "question",
        },
        {
            id: "vc-evt5",
            type: "event",
            level: 4,
            position: { x: 280, y: 242 },
            eventId: "evt-vc-05",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/victoria/map-victoria-event-5.png"),
                width: 409,
                height: 335,
            },
        },
        {
            id: "vc-end",
            type: "end",
            level: 5,
            position: { x: 755, y: 95 },
            playerAnchor: { y: 40 },
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/victoria/map-victoria-target.png"),
                width: 184,
                height: 212,
            },
        },
    ],
    edges: [
        { from: "vc-start", to: "vc-brigid", waypoints: [] },
        { from: "vc-brigid", to: "vc-evt4", waypoints: [] },
        { from: "vc-brigid", to: "vc-evt3", waypoints: [] },
        { from: "vc-evt4", to: "vc-heidi", waypoints: [] },
        { from: "vc-evt4", to: "vc-evt2", waypoints: [] },
        { from: "vc-evt3", to: "vc-evt1", waypoints: [] },
        { from: "vc-heidi", to: "vc-evt5", waypoints: [] },
        { from: "vc-evt1", to: "vc-evt2", waypoints: [] },
        { from: "vc-evt5", to: "vc-end", waypoints: [] },
        { from: "vc-evt2", to: "vc-end", waypoints: [] },
    ],
}
